/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import LocalizationUIAssets from '../Localization-UIAssets';
import ABCyaLib from '@abcya/abcya_lib';

/**
 * This is your first scene.
 */
export default class Title extends Phaser.Scene {
  static get KEY() { return 'Title'; }

  create() {
    this.cameras.main.setBackgroundColor('#FFFFFF');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.player = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.checkHeader = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredHeader', this).setOrigin(0, 0);
    this.checkerFooter = ABCyaPhaser.Images.addImage(0, this.mid.y * 2, 'CheckeredHeader', this).setScale(1, -1)
      .setOrigin(0, 0);

    this.logoContainer = this.add.container();

    this.logo = ABCyaPhaser.Images.addImage(0, 0, LocalizationUIAssets._TitleLogo, this.logoContainer, ABCyaPhaser.Images.LOCALIZATION_ATLAS);

    this.dotPop(this.logo, 600);

    ABCyaPhaser.Audio.playOneShot('race_car_drive_by', this);

    if (gameData.GAME_TYPE === 'jr') {
      this.jrdot = ABCyaPhaser.Images.addImage(0, 0, 'TitleJrLogo', this.logoContainer).setScale(2)
        .setAlpha(0);
      this.jrTxt = this.add.bitmapText(0, -5, 'asapBoldItalic', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.jr'), 100)
        .setOrigin(.5)
        .setScale(2)
        .setAlpha(0);
      this.logoContainer.add(this.jrTxt);

      ABCyaPhaser.Tweens.addTween(this.jrdot, 300, { delay: 330, scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.In);
      ABCyaPhaser.Tweens.addTween(this.jrTxt, 300, { delay: 330, scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.In);

      ABCyaPhaser.Audio.playSound('raceway-01', this.player);
    }
    else {
      ABCyaPhaser.Audio.playSound('raceway-02', this.player);
    }
    this.player.once('complete', () => { this.fadeTitleIn(); });

    this.titleLabel = ABCyaPhaser.Images.addImage(0, 0, 'TitleText', this).setOrigin(0, 0);
    this.titleLabel.alpha = 0;

    this.txtContainer = this.add.container(ABCyaLib.Environment.instance.gameConfig.title.titleX, this.mid.y * 2 - 262).setAlpha(0);
    const title1 = this.add.bitmapText(ABCyaLib.Environment.instance.gameConfig.title.title1X, 0, 'asapBoldItalicSmall', ABCyaPhaser.Localization.instance.getLocalizedString('title.title_1'), 42).setTintFill('0x980b0d');
    const title2 = this.add.bitmapText(this.mid.x - ABCyaLib.Environment.instance.gameConfig.title.title2X, 0, 'asapBoldItalicSmall', ABCyaPhaser.Localization.instance.getLocalizedString('title.title_2'), 42).setTintFill('0x980b0d');
    const title3 = this.add.bitmapText(this.mid.x + ABCyaLib.Environment.instance.gameConfig.title.title3X, 0, 'asapBoldItalicSmall', ABCyaPhaser.Localization.instance.getLocalizedString('title.title_3'), 42).setTintFill('0x980b0d');
    this.txtContainer.add([title1, title2, title3]);

    this.btnGo = this.add.container(0, -180).setAlpha(0);
    const btnGoBG = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'BtnGo', null, () => {
      btnGoBG.setEnabled(false);
      this.onClickGo();
    }, this.btnGo, { disabledTint: '0xFFFFFF' }).setEnabled(false);
    const btnTxt = this.add.bitmapText(0, -4, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.go'), 48).setTintFill('0xFFFFFF')
      .setOrigin(.5);
    this.btnGo.add(btnTxt);

    this.layoutRatio();
  }

  layoutRatio() {
    this.checkerFooter.y = this.mid.y * 2;

    this.logoContainer.scale = 1;
    this.logo.x = this.mid.x;
    this.logo.y = 280;
    this.titleLabel.y = this.mid.y * 2 - 262;

    if (this.jrdot) {
      this.jrdot.x = this.logo.x + 286;
      this.jrdot.y = this.logo.y + 68;
      this.jrTxt.x = this.jrdot.x;
      this.jrTxt.y = this.jrdot.y - 10;
    }
    this.titleLabel.x = this.mid.x - this.titleLabel.getBounds().width / 2 + ABCyaLib.Environment.instance.gameConfig.title.titleX;

    this.btnGo.x = this.mid.x;
    this.btnGo.y = this.mid.y * 2 - this.btnGo.getBounds().height / 2 - 88;
  };

  dotPop(obj, time = 320, wait = 0, enableBtn = false) {
    ABCyaPhaser.Tweens.addTween(obj, 240, { delay: wait, scaleX: 1.6, scaleY: 1.6, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      ABCyaPhaser.Tweens.addTween(obj, time, { scaleX: 1.0, scaleY: 1.0, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        if (enableBtn) obj.list[0].setEnabled(true);
      });
    });
  };

  fadeTitleIn() {
    ABCyaPhaser.Audio.playSound('raceway-03', this.player);
    ABCyaPhaser.Tweens.addTween(this.titleLabel, 500, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => { this.showGo(); });
    ABCyaPhaser.Tweens.addTween(this.txtContainer, 500, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  };

  showGo() {
    this.btnGo.scale = 0;
    this.btnGo.alpha = 0;
    this.dotPop(this.btnGo, 500, 0, true);
  };

  onClickGo() {
    let etype = '';
    this.player.stop();
    this.player.destroy();
    this.player = null;

    this.sound.stopAll();
    ABCyaPhaser.Audio.playOneShot('click', this);

    if (gameData.GAME_TYPE === 'jr') {
      etype = 'Questions';
    }
    else {
      etype = 'Select';
    }

    this.scene.start(etype);
  };
}